import styled from 'styled-components';

export const TableHeaderTextWrapper = styled.th`
    padding: 0px 16px 0px 16px;
`;
